import React, { FC, useState } from 'react'
import PhotoAlbum, { Photo } from 'react-photo-album'
import LightBox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'

interface Props {
  images: Photo[]
}

export const ImageGallery: FC<Props> = ({ images }) => {
  const [index, setIndex] = useState(-1)

  return (
    <>
      <PhotoAlbum
        layout="rows"
        photos={images}
        onClick={({ index: current }) => setIndex(current)}
        spacing={20}
      />

      <LightBox
        index={index}
        slides={images}
        open={index >= 0}
        close={() => setIndex(-1)}
        carousel={{ finite: true }}
        styles={{ container: { backgroundColor: '#000000c1' } }}
        controller={{ closeOnBackdropClick: true }}
      />
    </>
  )
}
